import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const TenantContext = createContext(null);

export function TenantProvider({ children }) {
  const { user } = useAuth();
  const [tenants, setTenants] = useState([]);
  const [tenant, setTenant] = useState(null);

  useEffect(() => {
    if (!user) return;
    api.get("/tenants").then(({ data }) => {
      setTenants(data);
      const saved = localStorage.getItem("evos_tenant");
      const found = data.find((t) => t.id === saved);
      setTenant(found || data[0]);
    }).catch(() => {});
  }, [user]);

  const switchTenant = (id) => {
    const t = tenants.find((x) => x.id === id);
    if (t) {
      setTenant(t);
      localStorage.setItem("evos_tenant", t.id);
    }
  };

  return (
    <TenantContext.Provider value={{ tenants, tenant, switchTenant }}>
      {children}
    </TenantContext.Provider>
  );
}

export const useTenant = () => useContext(TenantContext);
